/* Asavya — carrousel a defilement infini (partage entre sections).
   Usage : sur le conteneur scrollable
     data-asv-loop
     data-asv-loop-slide=".ma-classe-slide"
     data-asv-loop-dots="#mes-puces"
   Les clones portent data-asv-clone (a masquer en CSS sur desktop). */
(function () {
  if (window.__asvLoopCarousel) return;
  window.__asvLoopCarousel = true;

  function init(track) {
    if (track.__asvLoopReady) return;

    var slideSel = track.getAttribute('data-asv-loop-slide');
    var dotsSel = track.getAttribute('data-asv-loop-dots');
    if (!slideSel) return;

    var real = Array.prototype.slice.call(track.querySelectorAll(slideSel));
    var n = real.length;
    if (n < 2) return;

    var dotsWrap = dotsSel ? document.querySelector(dotsSel) : null;
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];

    var C = Math.min(2, n); /* nb de clones de chaque cote (marge de securite) */

    function w() { return track.clientWidth; }
    function pos() { return w() ? Math.round(track.scrollLeft / w()) : 0; }
    function realIndex() { return (((pos() - C) % n) + n) % n; }

    /* saut instantane : on neutralise snap + smooth, sinon iOS/Safari peut l'annuler */
    function jump(i) {
      var snap = track.style.scrollSnapType;
      var beh = track.style.scrollBehavior;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = i * w();
      void track.offsetWidth; /* reflow */
      track.style.scrollSnapType = snap || '';
      track.style.scrollBehavior = beh || '';
    }

    function makeClone(node) {
      var c = node.cloneNode(true);
      c.setAttribute('data-asv-clone', '1');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('id');
      Array.prototype.forEach.call(c.querySelectorAll('img'), function (im) {
        im.removeAttribute('loading'); /* les clones doivent etre prets avant le swipe */
      });
      Array.prototype.forEach.call(c.querySelectorAll('[id]'), function (el) {
        el.removeAttribute('id');
      });
      return c;
    }

    /* [C derniers] + [slides reels] + [C premiers] */
    for (var a = 0; a < C; a++) {
      track.insertBefore(makeClone(real[n - 1 - a]), track.firstChild);
    }
    for (var b = 0; b < C; b++) {
      track.appendChild(makeClone(real[b]));
    }

    function paint() {
      var r = realIndex();
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('is-on', j === r);
      }
    }

    /* ramene toujours la position dans la plage reelle [C, C+n-1] */
    function recenter() {
      if (!w()) return;
      var p = pos();
      if (p < C) jump(p + n);
      else if (p > C + n - 1) jump(p - n);
      paint();
    }

    /* Detection de fin de defilement par sondage : ne depend ni de
       requestAnimationFrame ni de l'evenement scrollend (absent sur d'anciens iOS). */
    var pollId = null, lastPos = -1, stable = 0, ticks = 0;
    function stopPoll() { if (pollId) { clearInterval(pollId); pollId = null; } }
    function startPoll() {
      if (pollId) { stable = 0; ticks = 0; return; }
      lastPos = -1; stable = 0; ticks = 0;
      pollId = setInterval(function () {
        var sl = track.scrollLeft;
        if (sl === lastPos) stable++; else { stable = 0; lastPos = sl; }
        ticks++;
        if (stable >= 2 || ticks > 60) { stopPoll(); recenter(); }
      }, 80);
    }

    track.addEventListener('scroll', function () { paint(); startPoll(); }, { passive: true });
    track.addEventListener('touchend', startPoll, { passive: true });
    track.addEventListener('scrollend', function () { stopPoll(); recenter(); });

    dots.forEach(function (d, i) {
      var idx = parseInt(d.getAttribute('data-idx'), 10);
      if (isNaN(idx)) idx = i;
      d.addEventListener('click', function () {
        track.scrollTo({ left: (C + idx) * w(), behavior: 'smooth' });
      });
    });

    /* au redimensionnement, la largeur d'un slide change : on se recale */
    var rz = null;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      var r = realIndex();
      rz = setTimeout(function () { if (w()) { jump(C + r); paint(); } }, 150);
    });

    function start() {
      if (!w()) return false;
      jump(C);
      paint();
      track.__asvLoopReady = true;
      return true;
    }
    if (!start()) {
      /* section encore masquee / pas encore mesuree : on retente */
      window.addEventListener('load', start, { once: true });
      var tries = 0;
      var retry = setInterval(function () {
        if (start() || ++tries > 40) clearInterval(retry);
      }, 100);
    }
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-asv-loop]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
